import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("../views/Home.vue"),
  },
  {
    path: "/Login",
    name: "Login",
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/Identity",
    name: "Identity",
    component: () => import("../views/Identity.vue"),
  },
  {
    path: "/about",
    name: "about",
    component: () => import("../views/about.vue"),
  },
  {
    path: "/cooperate",
    name: "cooperate",
    component: () => import("../views/cooperate.vue"),
  },
  {
    path: "/profile",
    name: "profile",
    component: () => import("../views/profile.vue"),
  },
  {
    path: "/wechatlandpage",
    name: "wechatlandpage",
    component: () => import("../views/wechatlandpage.vue"),
  },
  {
    path: "/MP_verify_e1Jn5RMu7wlAKtdw.txt",
    redirect: "/MP_verify_e1Jn5RMu7wlAKtdw.txt",
  },
  {
    path: "/MP_verify_AfFeUbAOqt4I63NK.txt",
    redirect: "/MP_verify_AfFeUbAOqt4I63NK.txt",
  },
  {
    path: "/wechatAuth.html",
    redirect: "/wechatAuth.html",
  },
  {
    path: "/textCopy.html",
    redirect: "/textCopy.html",
  },
  // {
  //   path: "/paypallandpage",
  //   name: "paypallandpage",
  //   component: () => import("../views/paypallandpage.vue"),
  // },
  {
    path: "/wallpaper",
    name: "wallpaper-layout",
    component: () => import("../layout/wallpaper.vue"), //使用layout
    children: [
      {
        //具体的页面
        path: "",
        name: "home",
        component: () => import("../views/wallpaper/home.vue"),
      },
      {
        path: "draw",
        name: "draw",
        component: () => import("../views/wallpaper/draw.vue"),
        meta: {
          title: "Dreamrail - DIY火车壁纸",
        },
      },
      {
        path: "drawSticker",
        name: "drawSticker",
        component: () => import("../views/wallpaper/drawSticker.vue"),
        meta: {
          title: "Dreamrail - DIY火车壁纸",
        },
      },
      {
        path: "drawCalendar",
        name: "drawCalendar",
        component: () => import("../views/wallpaper/drawCalendar.vue"),
        meta: {
          title: "Dreamrail - DIY火车壁纸",
        },
      },
      {
        path: "drawAvatar",
        name: "drawAvatar",
        component: () => import("../views/wallpaper/drawAvatar.vue"),
        meta: {
          title: "Dreamrail - DIY头像",
        },
      },
      {
        path: "square",
        name: "square",
        component: () => import("../views/wallpaper/square.vue"),
      },
      {
        path: "PCsquare",
        name: "PCsquare",
        component: () => import("../views/wallpaper/PCsquare.vue"),
      },
      {
        path: "avatarSquare",
        name: "avatarSquare",
        component: () => import("../views/wallpaper/avatarSquare.vue"),
      },
      {
        path: "paysuccess",
        name: "paysuccess",
        component: () => import("../views/wallpaper/paysuccess.vue"),
      },
      {
        path: "draftList",
        name: "draftList",
        component: () => import("../views/wallpaper/draftList.vue"),
      },
      {
        path: "orderList",
        name: "orderList",
        component: () => import("../views/wallpaper/orderList.vue"),
      },
      {
        path: "orderdetail",
        name: "orderdetail",
        component: () => import("../views/wallpaper/orderdetail.vue"),
      },
      {
        path: "sharedetail",
        name: "sharedetail",
        component: () => import("../views/wallpaper/sharedetail.vue"),
      },
      {
        path: "sharephone",
        name: "sharephone",
        component: () => import("../views/wallpaper/sharephone.vue"),
      },
    ],
  },
  {
    path: "/wallet",
    name: "wallet",
    component: () => import("../views/wallet.vue"),
  },
  {
    path: "/wallet/recharge",
    name: "walletRecharge",
    component: () => import("../views/walletRecharge.vue"),
  },
  {
    path: "/wallet/paysuccess",
    name: "walletPaysuccess",
    component: () => import("../views/walletPaysuccess.vue"),
  },
  {
    path: "/store",
    name: "store-layout",
    component: () => import("../layout/store.vue"), //使用layout
    children: [
      {
        //具体的页面
        path: "",
        name: "home",
        component: () => import("../views/store/home.vue"),
      },
      {
        path: "paysuccess",
        name: "paysuccess",
        component: () => import("../views/store/paysuccess.vue"),
      },
      {
        path: "orderdetail",
        name: "orderdetail",
        component: () => import("../views/store/orderdetail.vue"),
      },
      {
        path: "orderList",
        name: "orderList",
        component: () => import("../views/store/orderList.vue"),
      },
      {
        path: "sharedetail",
        name: "sharedetail",
        component: () => import("../views/store/sharedetail.vue"),
      },
    ],
  },
  {
    path: "/activity",
    name: "activity-layout",
    component: () => import("../layout/activity.vue"), //使用layout
    children: [
      {
        //具体的页面
        path: "",
        name: "home",
        component: () => import("../views/activity/home.vue"),
      },
      {
        path: "detail",
        name: "detail",
        component: () => import("../views/activity/detail.vue"),
      },
      {
        path: "mylist",
        name: "mylist",
        component: () => import("../views/activity/mylist.vue"),
      },
    ],
  },
  {
    path: "/railsearch",
    name: "railsearch-layout",
    component: () => import("../layout/railsearch.vue"), //使用layout
    children: [
      {
        //具体的页面
        path: "",
        name: "home",
        component: () => import("../views/railsearch/home.vue"),
      },
    ],
  },
  {
    path: "/getTicket",
    name: "getTicket",
    component: () => import("../views/activity/getTicket.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = "Dreamrail - 做世界优秀火车文化的传播者";
  }
  next();
});
export default router;
